import MarkerLayer from './_base/MarkerLayer';
import GPlacesProvider from '../dataProviders/GPlacesProvider';

export default MarkerLayer.extend({
  /**
   * @memberOf module:Layers 
   * @class GooglePlaces
   * @classdesc Overrides GeoPoints in order to handle points from Google Places API
   * @extends GeoPoints
   * @param {object} options - The options provided by json
   * @example <caption>Google Places Layer example/caption>
      widget: this,
      id: 'GooglePlaces',
      active: true,
      cleanMarkers: true,
      categories: ['restaurant'],
      minZoom: 10,
      iconMarker: {
        default: {
          url: '06marker_otherPOI_hov.png'
        }
      }
  */
  constructor(options) {
    this._initConfig(options);
    MarkerLayer.prototype.constructor.call(this, options);
  },

  /**
   * Initialize the layer
   */
  initialize(options) {
    options.provider = new GPlacesProvider(options);
    MarkerLayer.prototype.initialize.call(this, options);
  },
  /**
   * @typedef {object} GooglePlaces 
   * @property {string} type The type of the layer. Must be GooglePlaces.
   * @property {boolean} active To activate the layer by default
   * @property {boolean} searchOnce To do the search of the features only once
   * @property {number} [minZoom=1] The min zoom from the layer is visible
   * @property {boolean} [markersClickable=true] To do the markers clickables or not
   * @property {boolean} [searchDelay=100] Timeout to avoid do a search several times on 'idle'
   * @property {boolean} [cleanMarkers=true] To remove the markers before doing a new processment
   * @property {core.Config.IconMarker} iconMarker The icon of the markers
   * @memberof core.Config 
   */

  /**
   * Initialize the config.
   * @param {object} options The options
   */
  _initConfig(options) {
    //Pre-Filters doesn't apply to this layer
    options.preFilters = [];
    //Post-Filters doesn't apply to this layer
    options.postFilters = [];
    //Always place_id
    options.featureId = 'place_id';
    //This option does the markers clickables or not
    options.markersClickable = options.markersClickable ? options.markersClickable : true;
    //The provider doesn't load feature if it is not visible in a certain level zoom
    options.minZoom = options.minZoom ? options.minZoom : 1;
    //This option is to avoid several requests in a short time
    options.searchDelay = options.searchDelay ? options.searchDelay : 100;
    //Clean the markers after a load
    options.cleanMarkers = options.cleanMarkers ? options.cleanMarkers : true;
  },

  /**
   * Add the layer
   */
  add() {
    this.options.provider.onReady();
  }
});



// WEBPACK FOOTER //
// ./lmm-widget/src/layers/types/GooglePlaces.js